import { render } from "./Features.vue?vue&type=template&id=337151ec&scoped=true"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"

import "./Features.vue?vue&type=style&index=0&id=337151ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-337151ec"

export default script